export const data = () => ({
    plans: [],
});
const moduleExports = {
    data,
    methods: {
        /**
         * @param {{ allPlans?: boolean }} [options] - allPlans: true to include all plans (all regions, including deprecated) for display only (e.g. world view current plan name when traveling)
         */
        getPlans(options = {}) {
            const params = options.allPlans ? { all_plans: 1 } : {};
            return axios.get("/spark/plans", { params }).then((response) => {
                this.plans = _.filter(response.data, { type: "team" });
            });
        },
        getPlanById(id) {
            return this.plans.find((c) => c.id === id);
        },
    },
};
export default moduleExports;
export const methods = moduleExports.methods;
